export default "/images/vendor/flag-icon-css/flags/4x3/sj.svg?4952c9a6d03f7d9caa08bffd322b3bce";